import { render, staticRenderFns } from "./ShipDetailBanner.vue?vue&type=template&id=4fd4c68f&scoped=true"
import script from "./ShipDetailBanner.vue?vue&type=script&lang=js"
export * from "./ShipDetailBanner.vue?vue&type=script&lang=js"
import style0 from "./ShipDetailBanner.vue?vue&type=style&index=0&id=4fd4c68f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd4c68f",
  null
  
)

export default component.exports